import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  template: '<mat-progress-spinner class="padded-top" mode="indeterminate"></mat-progress-spinner>',
})
export class LoadingIndicatorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
